import { useState } from "react";
import { Badge2 } from "@/ui2/atoms/Badge";
import { Button2 } from "@/ui2/atoms/Button";
import EyeIcon from "@/assets/images/icons2/icon--eye.svg?component";
import { IdentityDocumentPreviewModal } from "./IdentityDocumentPreviewModal";
import type { UUID } from "@/core/types";

type IdentityDocumentPreviewButtonProps = {
  entityId?: UUID;
  isDisabled?: boolean;
};

export function IdentityDocumentPreviewButton({
  entityId,
  isDisabled,
}: IdentityDocumentPreviewButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="tw:flex tw:items-center tw:gap-2">
        <Badge2 size="sm" variant="outline-success" className="tw:h-auto">
          Uploaded
        </Badge2>
        <Button2
          onPress={() => setIsModalOpen(true)}
          isDisabled={isDisabled}
          variant="text"
          size="sm"
          icon={<EyeIcon />}
          classNameChildren="tw:flex tw:gap-1"
        >
          View
        </Button2>
      </div>

      <IdentityDocumentPreviewModal
        entityId={entityId}
        onOpenChange={setIsModalOpen}
        isModalOpen={isModalOpen}
      />
    </>
  );
}
